// extracted by mini-css-extract-plugin
export default {"videoContainer":"UpdateContext_videoContainer__DdQH5","videoFrame":"UpdateContext_videoFrame__e0h85"};